import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from 'firebase/functions';
import { initializeApp } from 'firebase/app';
import type { FnInput, FnResult, FunctionsApi } from 'functions';
import getEnvironmentVariables from './getEnvironmentVariables';

const env = getEnvironmentVariables();

const app = initializeApp({
  apiKey: env.TODESKTOP_CLI_FIREBASE_API_KEY,
  authDomain: env.TODESKTOP_CLI_FIREBASE_AUTH_DOMAIN,
  databaseURL: env.TODESKTOP_CLI_FIREBASE_DATABASE_URL,
  projectId: env.TODESKTOP_CLI_FIREBASE_PROJECT_ID,
  storageBucket: env.TODESKTOP_CLI_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.TODESKTOP_CLI_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.TODESKTOP_CLI_FIREBASE_ID,
});

const functions = getFunctions(app);

const firebaseFunctionsBase = env.TODESKTOP_CLI_FIREBASE_FUNCTIONS_BASE || '';
if (firebaseFunctionsBase.includes('localhost')) {
  const firebaseUrl = new URL(firebaseFunctionsBase);
  connectFunctionsEmulator(
    functions,
    firebaseUrl.hostname,
    parseInt(firebaseUrl.port),
  );
}

function getCallableFirebaseFunction<K extends keyof FunctionsApi>(
  functionName: K,
): ReturnType<typeof httpsCallable<FnInput<K>, FnResult<K>>>;

function getCallableFirebaseFunction(
  functionName: string,
): ReturnType<typeof httpsCallable>;
function getCallableFirebaseFunction(functionName: string) {
  return httpsCallable(functions, functionName);
}

export default getCallableFirebaseFunction;
